import * as THREE from 'three'
import { ThreeItemKeys } from '../constants/three'

export const getPrinterColor = (object?: THREE.Object3D) => object?.userData[ThreeItemKeys.PRINTER_COLOR]
export const getPrinterId = (object?: THREE.Object3D) => object?.userData[ThreeItemKeys.PRINTER_ID]
export const getPrinterAreaType = (object?: THREE.Object3D) => object?.userData[ThreeItemKeys.AREA_TYPE]
export const getPrinterGridType = (object?: THREE.Object3D) => object?.userData[ThreeItemKeys.GRID_TYPE]
